export function stringifyWithLimit(obj: any, limit: number) {
    try {
        return JSON.stringify(obj).substring(0, limit);
    } catch {
        return '[stringifyWithLimit] Cant stringify obj';
    }
}
